import AppEvents from 'Shared/app-events';
import ds from 'Shared/ds';
import modal from 'Shared/modal';

export default class CartApi {

    static onChanged = handler => AppEvents.on(this.Events.CART_CHANGED, handler);
    static #changed = (result) => {
        if (result.Success) {
            AppEvents.emit(this.Events.CART_CHANGED);
        }
    }

    static changing = () => AppEvents.emit(this.Events.CART_CHANGING);
    static changed = () => AppEvents.emit(this.Events.CART_CHANGED);

    static data = (cartId) => ds.get(this.#const.CART_DATA, { cartId } , false);

    static measures = (data) => ds.get(this.#const.MEASURES, data);

    static createCart = () => ds.post(this.#const.CART_CREATE);

    static editCart = () => modal
        .load(this.#const.CART_EDIT)
        .then(this.#changed);

    static changeBillingAddress = (id) => ds.post(this.#const.CART_CHANGE_BILLINGADDRESS, { id: id })
        .done(this.#changed);

    static changeShippingAddress = (id) => ds.post(this.#const.CART_CHANGE_SHIPPINGADDRESS, { id: id})
        .done(this.#changed);

    static updateCartContext = (data) => ds.post(this.#const.CARTCONTEXT_UPDATE, data)
        .done(this.#changed);

    static extendedUnit = (url, data) => modal.load(url, data)
        .done(this.#changed);

    static deleteCart = () => ds.post(this.#const.CART_DELETE, {});
    
    static select = (cartId) => ds.post(this.#const.CART_SWITCH, { cartId })
        .done(this.#changed);
    
    static copyCart = () => ds.post(this.#const.CART_COPY, { })
        .done(this.#changed);
    
    static transferTo = (cartId, userId) => ds.post(this.#const.CART_TRANSFER, { cartId, userId })
        .done(this.#changed);
    
    static changeCartName = (name) => ds.post(this.#const.CART_CHANGE_TITLE, { CartName: name })
        .done(this.#changed);
    
    static deleteCartContext = (contextId) => ds.post(this.#const.CARTCONTEXT_DELETE, { contextId })
        .done(this.#changed);

    static selectSupplyType = () => ds.get(this.#const.CART_CHANGE_SUPPLYTYPE);

    static selectStorage = (id) => ds.post(this.#const.CART_CHANGE_STORAGE, { id })
        .done(this.#changed);

    static changeBudget = (budgetId) => ds.post(this.#const.CART_CHANGE_BUDGET, { budgetId })
        .done(this.#changed);
    
    static applyVoucher = (voucherCode) => ds.post(this.#const.CART_APPLY_VOUCHER, { voucherCode })
        .done(this.#changed);

    static removeVoucher = (voucherCode) => ds.post(this.#const.CART_REMOVE_VOUCHER, { voucherCode })
        .done(this.#changed);

    static changeProject = (NVProjectId, itemIds) => ds.post(this.#const.CHANGE_PROJECT, { NVProjectId, itemIds })
        .done(this.#changed);

    static price = (data) => ds.get(this.#const.CART_PRICE, data);

    static acceptQuantity = (itemId, productId, productUnitId, result) => {
        var data = {
            ShoppingCartItemId: itemId,
            ProductId: productId,
            ProductUnitId: productUnitId,
            OrderQuantity: result.OrderQuantity,
            PossibleQuantity: result.PossibleQuantity,
            FormattedReferenceUnits: result.FormattedReferenceUnits
        };

        return modal.load(this.#const.ACCEPT_QUANTITY, data)
            .done(this.#changed);
    }

    static addProduct = async (data) => {
        //var result = await this.checkQuantity(productId, productUnitId, quantity);

        //if (result && !result.IsValid) {
        //    AppEvents.emit(this.Events.INVALID_QUANTITY, { productId, productUnitId, checkResult: result });
        //    //await this.acceptQuantity(null, productId, productUnitId, result);
        //    return;
        //}

        this.changing();

        var result = await ds.post(this.#const.ADD_PRODUCT, data)
            .done(this.#changed);

        return result;
    }

    static addProducts = async (products) => {
        this.changing();

        var result = await ds.post(this.#const.ADD_PRODUCTS, { items: products })
            .done(this.#changed);
    }

    static bonusProducts = () => ds.get(this.#const.BONUSPRODUCTS);

    static addBonusProduct = (voucherId, sku) => ds.post(this.#const.ADD_BONUSPRODUCT, { voucherId, sku })
        .done(this.#changed);

    static selectBatch = (itemId, batchId) => modal.load(this.#const.BATCH_SELECT, { itemId, batchId });
    
    static addFromOrder = (orderId, itemIds) => {
        var url = this.#const.ADD_FROM_ORDER,
            data = {
                OrderId: orderId,
                SelectedItems: itemIds
            };

        return ds.post(url, data)
            .done(this.#changed);
    }

    static createFromOrder = (orderId, itemIds) => {
        var url = this.#const.CREATE_FROM_ORDER,
            data = {
                OrderId: orderId,
                SelectedItems: itemIds
            };

        return ds.post(url, data).done(this.#changed);
    }

    static createFromOffer = (offerId, items) => {
        var url = this.#const.CREATE_FROM_OFFER,
            data = {
                OfferId: offerId,
                Items: items
            };

        return ds.post(url, data)
            .done(this.#changed);
    }

    static punchoutFromOffer = (offerId, items) => {
        var url = this.#const.PUNCHOUT_FROM_OFFER,
            data = {
                OfferId: offerId,
                Items: items
            };

        return ds.post(url, data)
            .done(this.#changed);
    }

    static punchoutFromOrder = (orderId, items) => {
        var url = this.#const.PUNCHOUT_FROM_ORDER,
            data = {
                OrderId: orderId,
                Items: items
            };

        return ds.post(url, data)
            .done(this.#changed);
    }

    static createFromBookmark = (itemId, quantity) => ds
        .post(this.#const.CREATE_FROM_BOOKMARK, {
            ItemId: itemId,
            Quantity: quantity
        })
        .done(this.#changed);

    static deleteItem = (id) => ds
        .post(this.#const.CARTITEM_DELETE, { id })
        .done(this.#changed);
    
    static updateItem = (data) => ds.post(this.#const.CARTITEM_UPDATE, data)
        .done(this.#changed);
    
    static updateQuantity = async (itemId, quantity) => {
        var result = await CartApi.checkQuantity({ itemId: itemId, quantity: quantity });

        await this.updateItem({
            ItemId: itemId,
            Quantity: result.NewQuantity
        });
    }

    static itemComment = (itemId, comment) => ds.post(this.#const.CARTITEM_COMMENT, { itemId, comment })
        .done(this.#changed);

    static checkQuantity = (data) => ds.post(this.#const.CHECK_QUANTITY, data);

    static importCart = (formData) => ds.postFormData(this.#const.IMPORT, formData);
    static settings = () => ds.get(this.#const.SETTINGS);

    static #const = {
        CART_DATA: "/cart/data",
        CART_CREATE: "/cart/create",
        CART_EDIT: "/cart/edit",
        CART_DELETE: "/cart/delete",
        CART_COPY: "/cart/copy",
        CART_SWITCH: "/cart/switch/",
        CART_TRANSFER: "/cart/transfer",
        CART_CHANGE_TITLE: "/cart/title",
        CART_CHANGE_ORDERTYPE: "/cart/ordertype",
        CART_CHANGE_SUPPLYTYPE: "/cart/supplytype",
        CART_CHANGE_BILLINGADDRESS: "/cart/billingaddress",
        CART_CHANGE_SHIPPINGADDRESS: "/cart/shippingaddress",
        CART_CHANGE_STORAGE: "/cart/storage",
        CART_CHANGE_BUDGET: "/cart/budget",
        CART_APPLY_VOUCHER: "/cart/applyvoucher",
        CART_REMOVE_VOUCHER: "/cart/removevoucher",
        BONUSPRODUCTS: "/cart/bonusproducts",
        CARTCONTEXT_UPDATE: "/cart/context/update",
        CARTCONTEXT_DELETE: "/cart/context/delete",
        CARTCONTEXT_CHANGE_PROJECT: "/cart/selectproject",
        ADD_PRODUCT: "/cart/add/product",
        ADD_PRODUCTS: "/cart/add/products",
        ADD_BONUSPRODUCT: "/cart/addvoucherarticle",
        CHECK_QUANTITY: "/cart/checkquantity",
        ACCEPT_QUANTITY: "/cart/acceptquantity",
        ADD_FROM_ORDER: "/customer/order/addtocart",
        CREATE_FROM_ORDER: "/customer/order/createcart",
        CREATE_FROM_OFFER: "/customer/offer/createcart",
        PUNCHOUT_FROM_OFFER: "/customer/offer/punchout",
        PUNCHOUT_FROM_ORDER: "/customer/order/punchout",
        CARTITEM_DELETE: "/cart/item/delete",
        CARTITEM_UPDATE: "/cart/item/update",
        CARTITEM_COMMENT: "/cart/item/comment",
        BATCH_SELECT: "/cart/selectbatch",
        CHANGE_PROJECT: "/cart/project",
        BUDGET_SELECT: "/cart/budget",
        
        MEASURES: "/cart/measures",
        CART_PRICE: "/cart/price",
        IMPORT: "/cart/import",
        SETTINGS: "/cart/importsettings"
    };

    static Events = {
        ADD: "cart.add",
        CREATE_FROM_OFFER: "cart.create-from-offer",
        CART_CHANGING: "cart-changing",
        CART_CHANGED: "cart-changed",
        ITEM_DELETE: "cart-item-delete",
        EXTENDED_UNI_MEASURESUNIT: "cart.extendedunit.MeasuresUnit",
        EXTENDED_UNIT_STEELCONFIG: "cart.extendedunit.SteelConfig",
        EXTENDED_UNIT: "cart.extendedunit",
        EDIT_EXTENDED_UNIT: "cart.edit-extendedunit",
        EDIT_EXTENDED_UNIT_MEASURESUNIT: "cart.edit-extendedunit.MeasuresUnit",
        EDIT_EXTENDED_UNIT_STEELCONFIG: "cart.edit-extendedunit.SteelConfig",
        INVALID_QUANTITY: "cart.invalidquantity",

        SUPPLYTYPE: "cart.supplytype",
        ONLINESTORAGE: "cart.onlinestorage",
        PROJECT: "cart.project",
        BUDGET: "cart.budget",
    };
}